// extracted by mini-css-extract-plugin
module.exports = {"main":"screen_main__6OlAU","panel":"screen_panel__yKMR-","title":"screen_title__1Zwv6"};